<template>
  <div class="flex">
    <div v-if="currentVideoStauts === 'In Progress'">
      <div class="rounded-[8px] bg-[#FFF3C9] h-[28px] px-[8px] mr-[4px] flex">
        <img
          src="../../../../public/assets/icons/inprogress.png"
          class="pt-[9px] pb-[7px]"
          alt=""
        />
        <div
          class="text-[14px] leading-[16px] m-auto text-[#061F42] font-aktiv-grotesk font-medium pl-[6px]"
        >
          {{ currentVideoStauts }}
        </div>
      </div>
    </div>

    <div v-if="currentVideoStauts === 'Not Started'">
      <div class="rounded-[8px] bg-[#D3D8DE] h-[28px] px-[8px] mr-[4px] flex">
        <img
          src="../../../../public/assets/icons/notstarted.png"
          class="pt-[9px] pb-[7px]"
          alt=""
        />
        <div
          class="text-[14px] leading-[16px] m-auto text-[#061F42] font-aktiv-grotesk font-medium pl-[6px]"
        >
          {{ currentVideoStauts }}
        </div>
      </div>
    </div>

    <div v-if="currentVideoStauts === 'Completed'">
      <div class="rounded-[8px] bg-[#A9E8D5] h-[28px] px-[8px] mr-[4px] flex">
        <img src="../../../../public/assets/icons/completed.png" class="pt-[9px] pb-[7px]" alt="" />
        <div
          class="text-[14px] leading-[16px] m-auto text-[#061F42] font-aktiv-grotesk font-medium pl-[6px]"
        >
          {{ currentVideoStauts }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isVideo: {
      type: Boolean,
      required: true,
    },
    isExclusive: {
      type: Boolean,
      default: false,
    },
    isAudio: {
      type: Boolean,
      default: false,
    },
    hasChineseOverdub: {
      type: Boolean,
      default: false,
    },
    hasThaiOverdub: {
      type: Boolean,
      default: false,
    },
    hasChineseSub: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    translations: {
      type: Array,
      default: () => [],
    },
    currentVideoStauts: {
      type: String,
      default: '',
    },
  },
  computed: {},
};
</script>

<style></style>
